import { FC, useCallback, useState } from 'react';

import { Modal, TTab, Tabs } from '@cian/ui-kit';
import { EGeoType } from 'shared/selectors/filters/geo/selectGeoTypeFilter';
import { SearchButtonContainer } from '../GeoSuggestContainer/containers/SearchButtonContainer';
import { useAppDispatch, useJsonQueryBackup } from 'shared/hooks';
import { applyFilters } from 'shared/thunks/filters';
import { updateTags } from 'shared/thunks/tags';
import { RegionalDistrictsModalContainerV2 } from '../GeoSuggestContainer/containers/RegionalDistricts/ModalContainerV2';
import { UndergroundMapModalContainerV2 } from '../GeoSuggestContainer/containers/UndergroundContainer/MapModalContainerV2';
import { DirectionsModalContainerV2 } from '../GeoSuggestContainer/containers/DirectionsContainer/ModalContainerV2';
import { DistrictsModalContainerV2 } from '../GeoSuggestContainer/containers/DistrictsContainer/ModalContainerV2';

interface IGeoSuggestModalContainerType {
  tabItems: (TTab & { id: EGeoType })[];
  onModalClose: VoidFunction;
}

export const GEO_SUGGEST_OPTIONS = {
  [EGeoType.Underground]: <UndergroundMapModalContainerV2 />,
  [EGeoType.RegionalDistricts]: <RegionalDistrictsModalContainerV2 />,
  [EGeoType.District]: <DistrictsModalContainerV2 />,
  [EGeoType.Highway]: <DirectionsModalContainerV2 />,
};

export const GeoSuggestModalContainer: FC<IGeoSuggestModalContainerType> = ({ tabItems, onModalClose }) => {
  const dispatch = useAppDispatch();

  const { resetJsonQuery } = useJsonQueryBackup();

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabClick = (index: number): void => {
    setActiveTabIndex(index);
  };

  const handleClose = useCallback(() => {
    onModalClose();
    resetJsonQuery();
  }, [onModalClose, resetJsonQuery]);

  const handleApply = useCallback(async () => {
    onModalClose();
    dispatch(applyFilters());
    dispatch(updateTags(true));
  }, [dispatch, onModalClose]);

  return (
    <Modal
      size="L"
      open
      onOpenChange={handleClose}
      header={<Tabs onTabClick={handleTabClick} activeTabIndex={activeTabIndex} items={tabItems} size="S" />}
      body={GEO_SUGGEST_OPTIONS[tabItems[activeTabIndex].id]}
      footer={<SearchButtonContainer onClick={handleApply} />}
    />
  );
};
